import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { pingDb } from "../api/health";

function HomePage(){

    useEffect(function () {
        if (sessionStorage.getItem("db_ping_ok")) { return; }
        pingDb()
            .then(function () { console.log("Health DB OK"); })
            .catch(function (e) { console.warn("Health DB fail:", e); })
            .finally(function(){ sessionStorage.setItem("db_ping_ok", "1"); });
    }, []);

    return (
        <section className="hero position-relative">
            {/* drevený pás hore */}
            <div className="hero-woodbar" />

            <div className="container position-relative">
                <div className="row align-items-center py-5 py-lg-6">
                    {/* hodiny vľavo */}
                    <div className="col-12 col-lg-6 order-2 order-lg-1">
                        <div className="hero-clock-wrap">
                            <motion.img
                                src="/images/title.png"
                                alt="Drevené hodiny"
                                className="hero-clock"
                                initial={{ opacity: 0, y: 12, scale: 0.98 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                transition={{ duration: 0.55, ease: "easeInOut" }}
                            />
                        </div>
                    </div>

                    {/* text vpravo */}
                    <div className="col-12 col-lg-6 order-1 order-lg-2 text-center text-lg-start nadpis">
                        <h1 className="display-5 fw-bolder mb-1 nadpis">MČ WOODDESIGN</h1>
                        <div className="fs-3 mb-3 nadpis">výroba drevených dekorácií</div>

                        <p className="text-muted lead mb-4">
                            Špecializujeme sa najmä na nástenné hodiny s jedinečnými motívmi,
                            vzormi a nápismi, ktoré vnesú do vášho domova čaro prírodného
                            materiálu a poctivej práce.
                        </p>

                        <Link to="/ponuka" className="btn btn-brown px-4 py-2 rounded-pill">
                            naša ponuka
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default HomePage;

